import { render, staticRenderFns } from "./google-login-button.vue?vue&type=template&id=10e00d3f"
import script from "./google-login-button.vue?vue&type=script&lang=ts"
export * from "./google-login-button.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10e00d3f')) {
      api.createRecord('10e00d3f', component.options)
    } else {
      api.reload('10e00d3f', component.options)
    }
    module.hot.accept("./google-login-button.vue?vue&type=template&id=10e00d3f", function () {
      api.rerender('10e00d3f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/google-login-button.vue"
export default component.exports